export default __webpack_public_path__ + "static/media/warning--horizontal-alignment-right--g3.4a7db298.png";